module.exports = __webpack_public_path__ + "static/media/CloudDesktop_001.b50059ea.png";